import React from 'react';
import { MetaData } from '@jelly/components';
import Footer from './Footer';
import Header from './Header';
import Form from './Form';
import Packages from './Packages';
import TopBrands from './TopBrands';
import BuyingGuide from './BuyingGuide';
export var SQL = function SQL(_ref) {
  var meta = _ref.meta,
      headerData = _ref.headerData,
      formData = _ref.formData,
      packagesData = _ref.packagesData,
      brandData = _ref.brandData,
      buyingGuideData = _ref.buyingGuideData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MetaData, {
    meta: meta
  }), /*#__PURE__*/React.createElement(Header, {
    headerData: headerData
  }), /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement(Form, {
    formData: formData
  }), /*#__PURE__*/React.createElement(Packages, {
    packagesData: packagesData
  }), /*#__PURE__*/React.createElement(TopBrands, {
    brandData: brandData
  }), /*#__PURE__*/React.createElement(BuyingGuide, {
    buyingGuideData: buyingGuideData
  })), /*#__PURE__*/React.createElement(Footer, null));
};